"use strict";

exports.__esModule = true;
exports.humanizeString = humanizeString;
/**
 * Take a string like "part-count-good" and return "Part Count Good"
 */
function humanizeString(input) {
  if (!input) {
    return input;
  }
  return input.replace(/^[\s_|-]+|[\s_|-]+$/g, "").replace(/[_|-\s]+/g, " ").replace(/(\d+)([a-zA-Z])/g, function (a, b, c) {
    return b + " " + c;
  }).replace(/([a-z])([A-Z])/g, function (a, b, c) {
    return b + " " + c;
  }).replace(/^[a-z]/, function (m) {
    return m.toUpperCase();
  }).replace(/(\s+[a-z])/g, function (m) {
    return m.toUpperCase();
  });
}